import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Add from "./New";
import EditMembers from "./Edit";
import MembersList from "./List";
import MembersDetails from "./Details";
import EditProducts from "./Edit";
import ProductsDetails from "./Details";
import AddProductVariety from "./New";
import ProductVarietyDetails from "./Details";

function ProductVariety() {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path="list"
          element={
            <>
              <MembersList />
            </>
          }
        />
        <Route
          path="new"
          element={
            <>
              <AddProductVariety />
            </>
          }
        />
        <Route
          path="edit/:primary_id"
          element={
            <>
              <EditProducts />
            </>
          }
        />
        <Route
          path="details/:primary_id"
          element={
            <>
              <ProductVarietyDetails />
            </>
          }
        />

        <Route index element={<Navigate to="/product_variety/list" />} />
      </Route>
    </Routes>
  );
}

export default ProductVariety;
